import { Navigate } from "react-router";

import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";

import { LegacyProjectHomeContent } from "./LegacyProjectHomeContent";

export function LegacyProjectHomePage(): React.ReactNode {
  const slug = useSlug();
  const sessionUser = useSessionUser();

  if (sessionUser.role.type === "maintenance") {
    return <Navigate to={routes.tickets.list({ slug })} replace />;
  }

  if (sessionUser.role.type === "servicePartner") {
    return <Navigate to={routes.servicePartners.list({ slug })} replace />;
  }

  if (!sessionUser.isAdmin) {
    return <Navigate to={routes.communityFeed.list({ slug })} replace />;
  }

  return <LegacyProjectHomeContent />;
}
